<template>
  <div style="height:100%">
    <portal to="app-header">
      <v-btn class="mb-1" icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span>{{ $t('maintenanceTask.addTask') }}</span>
    </portal>
    <v-container fill-height v-if="loading">
      <v-row
        align="center"
        justify="center"
        :no-gutters="$vuetify.breakpoint.smAndDown"
      >
        <v-col cols="12" align="center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="72"
          ></v-progress-circular>
        </v-col>
        <v-col cols="12" align="center">
          <div class="headline">
            {{ $t('maintenanceTask.loadingTitle') }}
          </div>
          <div class="title">
            {{ $t('maintenanceTask.fetchingTask') }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <add-task v-else />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AddTask from '../components/actions/AddTask.vue';

export default {
  name: 'AddMaintenanceTask',
  components: {
    AddTask,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('maintenanceTask', ['machines', 'solutions']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  async created() {
    const machinesNotAvailable = this.machines.length === 0;
    const solutionsNotAvailable = this.solutions.length === 0;
    if (machinesNotAvailable || solutionsNotAvailable) {
      this.loading = true;
      await Promise.all([
        this.fetchMachines(),
        this.fetchSolutions(),
      ]);
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('maintenanceTask', [
      'fetchMachines',
      'fetchSolutions',
    ]),
    goBack() {
      this.$router.push({ name: 'maintenanceTask' });
    },
  },
};
</script>
